var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActionSign = function SvgActionSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#008060}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    transform: "translate(603.157 -1906.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_338",
    d: "M.9 0a.9.9 0 0 1 .9.9v.765H0V.9A.9.9 0 0 1 .9 0z",
    className: "cls-1",
    transform: "rotate(35 -3328.533 32.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_339",
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-603.157 1906.843)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    transform: "translate(-598.263 1911.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.311 6.649a2.493 2.493 0 0 1-2.494-2.494V.831H2.493A1.662 1.662 0 0 0 .831 2.493V13.3a1.662 1.662 0 0 0 1.662 1.662h7.48a1.662 1.662 0 0 0 1.662-1.662V6.649zM6.649 4.155a1.662 1.662 0 0 0 1.662 1.662h2.98L6.649 1.175zM2.493 0h4.156l5.817 5.817V13.3a2.493 2.493 0 0 1-2.493 2.49h-7.48A2.493 2.493 0 0 1 0 13.3V2.493A2.493 2.493 0 0 1 2.493 0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    fill: "#008060",
    stroke: "#fff",
    strokeWidth: "0.5px",
    d: "M0 7.454l1.17 1.553 1-1.553V0H0z",
    transform: "rotate(35 -1.592 23.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    fill: "none",
    stroke: "#008060",
    strokeLinecap: "round",
    strokeWidth: "0.5px",
    d: "M-606.75 1936.954c.182-.287.638-1.416.82-1.724s.638-.862.729-.128a1.963 1.963 0 0 1-.41 1.224 8.642 8.642 0 0 1 1.336-1.331c.394-.266-.679 1.04-.258 1.331s.517-.677 1.306-.5a8.816 8.816 0 0 0 2.293.628",
    transform: "translate(610.013 -1923.264)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action-sign.75eff904.svg";
export { ForwardRef as ReactComponent };